const getExistSmeta = async () => {

    return [
        {'code': 'Y', 'name': 'Бор'},
        {'code': 'N', 'name': 'Йўқ'},
    ]

};
export default getExistSmeta;